import type {
  SeriesKind,
  SeriesValueFormat,
} from "@/components_v2/Charts/types";

export const SERIES_KINDS = {
  BAR: "bar",
  LINE: "line",
  AREA: "area",
} as const satisfies Record<string, SeriesKind>;

export const SERIES_VALUE_FORMATS = {
  COUNT: "count",
  PERCENT: "percent",
} as const satisfies Record<string, SeriesValueFormat>;

export const LINE_WIDTH = 2;
export const POINT_RADIUS = 3;
export const POINT_HOVER_RADIUS = 5;
export const BAR_RADIUS = 2;
export const FILL_GAP_WIDTH = 2;
export const AREA_FILL_ALPHA = 0.35;
export const BAR_MAX_THICKNESS = 32;
export const PERCENT_SCALE = 100;

export const CHART_FONT_FAMILY = "Roboto";
export const CHART_FONT_SIZE = 12;

export const CHART_SURFACE_TOKEN = "var(--neutral-50)";
export const CHART_GRID_TOKEN = "var(--neutral-200)";
export const CHART_TICK_TOKEN = "var(--neutral-600)";
